import { createGlobalStyle } from 'styled-components';

const GlobalStyles = createGlobalStyle`

  *,
  *:before,
  *:after {
    margin: 0;
    padding: 0;
    box-sizing: inherit;
  }

  :root {
    --color-primary: #01bf71;
    --color-white: #fff;
    --color-black: #010606;
    --transition: all .5s ease;
    --transition-hover: .5s ease;
    --box-shadow: 0 1px 3px rgba(0,0,0, .2);
    --box-shadow-big: 10px 10px 20px rgba(0,0,0, .1);
  }

  html {
    box-sizing: border-box;
  }

  body {
  font-family: 'Fira Code', monospace;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  }

  h1, h2, h3, h4, h5, h6 {
    font-family: 'PT Sans', sans-serif;
    /* oswald regular */
  }

  code {
    font-family: source-code-pro, Menlo, Monaco, Consolas, "Courier New",
      monospace;
  }

`;

export default GlobalStyles;
